import { useEffect, useState } from 'react'

const REQUETE = '(min-width: 768px)'

/** Vrai à partir de la largeur « md » (768 px) : la mise en page de bureau. */
export function useEstDesktop(): boolean {
  const [desktop, setDesktop] = useState(
    () => typeof window !== 'undefined' && window.matchMedia?.(REQUETE).matches,
  )
  useEffect(() => {
    const mq = window.matchMedia?.(REQUETE)
    if (!mq) return
    const suivre = () => setDesktop(mq.matches)
    suivre()
    mq.addEventListener('change', suivre)
    return () => mq.removeEventListener('change', suivre)
  }, [])
  return desktop
}
